module.exports = __webpack_public_path__ + "img/navarra-full.dad5cc70.png";